module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Medium.3f21e146.ttf";